function addBodyTouchClass() {
    if ('ontouchstart' in document.documentElement) {
        $('body').addClass('touch-screen');
    }
}

function stickyHeader() {
    var header_width = $('#header .main-header > .container').width();
    if ($('.js-sticky-menu').length && header_width > 540) {
        $('.js-sticky-menu').sticky({
            wrapperClassName: 'desktop-sticky-wrapper'
        });

        $('.js-sticky-menu').on('sticky-start', function() {
            $('.js-sticky-icon-cart').html($('.js-sticky-cart-source').html());
        });
    }
    if ($('.js-mobile-sticky').length && header_width <= 540) {
        $('.js-mobile-sticky').sticky({
            wrapperClassName: 'mobile-sticky-wrapper'
        });
    }
}

function scrollToTopButton() {
    var $sttb = $('#js_scroll_to_top');
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $sttb.fadeIn();
        } else {
            $sttb.fadeOut();
        }
    });

    $sttb.find('a').smoothScroll({
        speed: 500,
    });
}

function loadPageWithProcessBar() {
    if ($('.js-page-progress-bar').length) {
        Pace.start();
    }
    $(window).load(function() {
        setTimeout(function(){
            Pace.stop();
            $('.js-page-progress-bar').removeClass('js-page-progress-bar');
        }, 100);
    });
}

function sliderHeaderMessages() {
    $('.header-messages').slick({
        arrows: false,
        infinite: false,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
    });
}

function addTooltip() {
    $('body:not(.touch-screen) [data-toggle="tooltip"]').tooltip({
        position: { my: "center bottom-8", at: "center top" },
        hide: false,
        show: false,
    });
}

function loadSidebarNavigation() {
    var resetMenu = function() {
            $('html').removeClass('st-menu-open st-effect-left st-effect-right');
        };

    $('#st_overlay').on('click', function(e){
        resetMenu();
    });
    $('.st-menu-close').on('click', function(e){
        resetMenu();
    });

    //$('#js-search-sidebar').removeClass('js-hidden').html($('.js-search-source').html());
    $('#js-header-phone-sidebar').removeClass('js-hidden').html($('.js-header-phone-source').html());
    $('#js-account-sidebar').removeClass('js-hidden').html($('.js-account-source').html());
    $('#js-language-sidebar').removeClass('js-hidden').html($('.js-language-source').html());
    if (!$('.js-sidebar-cart-enabled').length) {
        $('#js-left-currency-sidebar').removeClass('js-hidden').html($('.js-currency-source').html());
    }

    $('.js-left-nav-trigger').on('click', function(e){
        $('html').addClass('st-effect-left st-menu-open');
        return false;
    });
}

function loadSidebarCart() {
    if ($('.js-sidebar-cart-enabled').length) {
        $('#js-cart-sidebar').removeClass('js-hidden').html($('.js-cart-source').html());
        $('#js-currency-sidebar').removeClass('js-hidden').html($('.js-currency-source').html());

        $('.js-cart-source').addClass('d-none');

        $('.js-sidebar-cart-trigger').on('click', function(e){
            $('html').addClass('st-effect-right st-menu-open');
            return false;
        });
    }
}

function sidebarSubCategoriesTrigger() {
    var $subcats = $('.js-sidebar-categories');
    if ($subcats.length) {
        $subcats.find('.js-collapse-trigger').click(function(e) {
            $(this).next('.js-sub-categories').stop().slideToggle();
            $(this).find('.add').toggle();
            $(this).find('.remove').toggle();
        });
    }
}

function mobileMenuControl() {
  $('#mobile-menu-icon').on('click', function() {
    $('#dropdown-mobile-menu').stop().slideToggle();
  });
}

function updateCustomerDropdownMenu() {
    var $otherLinks = $('.js-otherCustomerDropdownLinks');
    if ($otherLinks.length) {
        $('.js-displayCustomerAccount a').each(function() {
            $(this).removeAttr('id').removeAttr('class').addClass('dropdown-item');
            var $span = $(this).find('span'),
                $i = $span.find('i');
            $span.removeAttr('class');
            $(this).remove('i');
            $(this).prepend($i);

            var $newThis = $(this).wrap('<li></li>').parent();
            $newThis.insertBefore($otherLinks);
        });
    }
}

function handleCookieMessage() {
    var $cookieMsg = $('.js-cookieMessage');
    if ($cookieMsg.length) {
        setTimeout(function(){
            $cookieMsg.cookieBar({
                closeButton : '.js-cookieCloseButton',
                path: prestashop.urls.base_url.substring(prestashop.urls.shop_domain_url.length)
            });
        }, 2000);
    }
}

function expandCategoryTree() {
    var currentCatID = $('body').data('current-category-id');

    if (currentCatID !== undefined) {
        var $currentCatObj = $('.js-category-tree [data-category-id=' + currentCatID + ']'),
            $currentSBCatObj = $('.js-sidebar-categories [data-category-id=' + currentCatID + ']');

        $currentCatObj.addClass('current');
        $currentCatObj.parents('li').each(function() {
            $(this).children('[data-toggle="collapse"]').attr('aria-expanded', 'true');
            $(this).children('.category-sub-menu.collapse').addClass('show');
        });

        $currentSBCatObj.addClass('current');
        $currentSBCatObj.parents('li').each(function() {
            $(this).children('.js-sub-categories').show();
            $(this).find(' > .js-collapse-trigger .add').hide();
            $(this).find(' > .js-collapse-trigger .remove').show();
        });
    }
}

function addCustomDropdown() {
    $('.js-dropdown-toggle').each(function() {
        var $title = $(this).find('.dropdown-title'),
            $content = $(this).find('.dropdown-content');
        $title.click(function() {
            $content.stop().slideToggle();
        });
    });
}

function categoryDescriptionExpand() {
    var $cat_description = $('.js-small-description');
    if ($cat_description.length) {
        if ($cat_description.height() > $cat_description.data('max-height')) {
            $cat_description.addClass('see-more');
            $('.js-expand-description').click(function() {
                $cat_description.removeClass('see-more');
                return false;
            });
        }
    }
}

loadPageWithProcessBar();

$(document).ready(function() {
    addBodyTouchClass();

    stickyHeader();
    scrollToTopButton();

    loadSidebarNavigation();
    loadSidebarCart();

    updateCustomerDropdownMenu();

    sidebarSubCategoriesTrigger();
    mobileMenuControl();
    expandCategoryTree();
    categoryDescriptionExpand();

    addCustomDropdown();
});
$(window).load(function() {
    addTooltip();
    handleCookieMessage();
});